document.addEventListener('DOMContentLoaded', function () {
    const modelBtns = document.querySelectorAll('[js-model-btn]');
    const modelSelectors = document.querySelectorAll('[js-model-selectors]');

    modelBtns.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
            event.stopPropagation(); 
            const parent = btn.parentElement;
            parent.classList.toggle('show');
        });
    });
    modelSelectors.forEach(function (selector) {
        selector.addEventListener('click', function (event) {
            event.stopPropagation(); 
        });
    });
    document.body.addEventListener('click', function () {
        document.querySelectorAll('.show').forEach(function (element) {
            element.classList.remove('show');
        });
    });
});



const filterOptions = document.querySelectorAll("[js-filter-options]");
const tagsWrapper = document.querySelector(".selected__tags_wrapper"); // Wrapper for the tags
const recipeGridItems = document.querySelectorAll("[js-recipe-grid-item]");
const mocktailSwitcher = document.querySelector("[js-mocktail-sweitcher]");

filterOptions.forEach((filterOption) => {
    filterOption.addEventListener("change", function () {
        applyFilters();
    });
});

mocktailSwitcher.addEventListener("change", function () {
    applyFilters();
});

function applyFilters() {
    document.querySelector(".recipe__loop__cover").classList.add("loading");

    setTimeout(function () {
        const checkedOptions = document.querySelectorAll("[js-filter-options]:checked");
        const isMocktailChecked = mocktailSwitcher.checked;

        tagsWrapper.innerHTML = "";

        // Add tags for selected filters
        checkedOptions.forEach((checkedOption) => {
            const tag = document.createElement("div");
            tag.className = "selected_tag";

            const removeIcon = document.createElement("span");
            removeIcon.className = "remove_tag_icon";
            removeIcon.innerHTML = `
            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2194_43585)">
                    <path d="M9.53564 2.96448L2.46458 10.0355" stroke="#EEEBE0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.53542 10.0355L2.46436 2.96448" stroke="#EEEBE0" stroke-width="2" stroke-linecap="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_2194_43585">
                        <rect width="12" height="12" fill="white" transform="translate(0 0.5)"/>
                    </clipPath>
                </defs>
            </svg>
            `;

            const tagText = document.createElement("span");
            tagText.className = "selected_tags_text";
            tagText.textContent = checkedOption.value;

            tag.appendChild(removeIcon);
            tag.appendChild(tagText);
            tagsWrapper.appendChild(tag);

            removeIcon.addEventListener("click", () => {
                checkedOption.checked = false; // Use `checkedOption` here instead of `filterOption`
                tag.remove();
                applyFilters(); // Reapply filters when a tag is removed
            });
        });

        // Add tag for Mocktail filter
        if (isMocktailChecked) {
            const mocktailTag = document.createElement("div");
            mocktailTag.className = "selected_tag";
            mocktailTag.setAttribute("data-type", "mocktails");

            const removeIcon = document.createElement("span");
            removeIcon.className = "remove_tag_icon";
            removeIcon.innerHTML = `
            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2194_43585)">
                    <path d="M9.53564 2.96448L2.46458 10.0355" stroke="#EEEBE0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.53542 10.0355L2.46436 2.96448" stroke="#EEEBE0" stroke-width="2" stroke-linecap="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_2194_43585">
                        <rect width="12" height="12" fill="white" transform="translate(0 0.5)"/>
                    </clipPath>
                </defs>
            </svg>
            `;

            const tagText = document.createElement("span");
            tagText.className = "selected_tags_text";
            tagText.textContent = "Mocktails";

            mocktailTag.appendChild(removeIcon);
            mocktailTag.appendChild(tagText);
            tagsWrapper.appendChild(mocktailTag);

            removeIcon.addEventListener("click", () => {
                mocktailSwitcher.checked = false;
                mocktailTag.remove();
                applyFilters(); // Reapply filters when mocktail tag is removed
            });
        }

        // Filter recipes based on selected filters and mocktail switcher
        recipeGridItems.forEach((recipeGridItem) => {
            const hasMatchingClass = Array.from(checkedOptions).some((checkedOption) => {
                return recipeGridItem.classList.contains(checkedOption.value);
            });

            const isMocktail = recipeGridItem.classList.contains("mocktails");
            const matchesFilters = checkedOptions.length === 0 || hasMatchingClass;

            // Apply both filtering rules
            if (isMocktailChecked) {
                if (matchesFilters && !isMocktail) {
                    recipeGridItem.classList.add("mocktails-hidden");
                } else if (matchesFilters && isMocktail) {
                    recipeGridItem.classList.remove("mocktails-hidden");
                }
            } else {
                recipeGridItem.classList.remove("mocktails-hidden");
            }

            // Apply `hidden` class for filter options
            if (!matchesFilters) {
                recipeGridItem.classList.add("hidden");
            } else {
                recipeGridItem.classList.remove("hidden");
            }
        });

        document.querySelector(".recipe__loop__cover").classList.remove("loading");
    }, 500);
}

